<template>
  <div class="wechat-web-container" @click="openWeapp">
    <slot></slot>
    <wx-open-launch-weapp
      style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
      id="launch-btn"
      username="gh_bd069c310855"
      :path="path"
    >
      <script type="text/wxtag-template">
        <div style="width: 100%; height: 100%; position: absolute; top: 0; left: 0;"
        ></div>
      </script>
    </wx-open-launch-weapp>
  </div>
</template>
<script>
import { generateScheme } from "@/api/index";
export default {
  name: "middlePage",
  props: {
    path: {
      type: String,
      value: "",
    },
  },
  methods: {
    //微信浏览器
    docReady() {
      var ua = navigator.userAgent.toLowerCase();
      var isWXWork = ua.match(/wxwork/i) == "wxwork";
      var isWeixin =
        !isWXWork && ua.match(/micromessenger/i) == "micromessenger";
      var isMobile = false;
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i
        )
      ) {
        isMobile = true;
      }
      if (isWeixin) {
        var launchBtn = document.getElementById("launch-btn");
        launchBtn.addEventListener("ready", function (e) {
          console.log("开放标签 ready");
        });
        launchBtn.addEventListener("launch", function (e) {
          console.log("开放标签 success");
        });
        launchBtn.addEventListener("error", function (e) {
          console.log("开放标签 fail", e.detail);
        });
      }
    },

    //除微信浏览器
    async openWeapp() {
      var that = this;
      var ua = navigator.userAgent.toLowerCase();
      var isWXWork = ua.match(/wxwork/i) == "wxwork";
      var isWeixin =
        !isWXWork && ua.match(/micromessenger/i) == "micromessenger";
      if (!isWeixin) {
        const res = await generateScheme({
          Path: that.path,
        });
        location.href = res.Data;
      }
    },
  },
  mounted() {
    this.docReady();
  },
};
</script>
<style scope>
.wechat-web-container {
  position: relative;
}
</style>